<div
  class="flex rounded-[4px] bg-white border border-solid border-gray-300 h-10 px-3 cursor-pointer transition hover:bg-[#f8faff] hover:border-blue-200"
  (click)="login()">
  <div class="text-[#4267B2] text-2xl font-semibold w-[10%] ml-1 leading-10">f</div>
  <div class="text-sm text-gray-700 font-medium text-center leading-10 w-[90%]">Sign in with Facebook</div>
</div>

<!-- <img #profileImg *ngIf="isUserLoggedWithFB" [matMenuTriggerFor]="actionMenu" [src]="profilePicture"
  alt="user profile picture" style="margin:10px 39%;width:46px;border-radius:23px;cursor: pointer"> -->
